import React from 'react';
import Paper from '@material-ui/core/Paper/Paper';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import i18n from '../../i18n';
import {withStyles} from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import {cleanPhone, getContactName} from '../Form/utils';
import Query from 'react-apollo/Query';
import {SubContacts} from './FormFields/SubContacts';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinkIconButton from '../Formater/LinkIconButton';
import PreviewButton from '../File/PreviewButton';
import Divider from '@material-ui/core/Divider';
import RenderContactDetailsFragment from './RenderContactDetailsFragment';
import NotesList from '../Notes/NotesList';
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCellSortable from "../Form/TableCellSortable";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody";
import ContactTable from "./ContactTable";

const renderDetailsRow = (label, value, classes) => {

    let phone = value.landline ? (value.landline && value.mobile) : null;
    let email = value.email && value.email;
    let name = value.first_name && value.last_name ? value.first_name + ' ' + value.last_name : value;

    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography className={classes.detailsLabel} component={'div'}
                                variant={'subtitle2'}>{(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        className={classes.detailsValue}
                        component={'div'}
                        variant={'body2'}>
                        {typeof name === 'string' && name}
                        {phone && (
                            <LinkIconButton
                                href={`tel:${cleanPhone(phone)}`}
                                text={phone}
                                icon={'phone'}
                                fontSize={'small'}
                                buttonProps={{style:{display: 'lowercase'}}}
                            />
                        )}
                        {email && (
                            <LinkIconButton
                                buttonProps={{style:{textTransform: 'lowercase'}}}
                                href={`mailto:${email}`}
                                text={email}
                                icon={'email'}
                                fontSize={'small'}
                            />
                        )}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

class ContactDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {contacts: ''};
    }

    setContacts  = (contacts) =>  {
        this.setState({contacts: contacts})
    };

    render() {
        const {contact, files, notes, classes} = this.props;

        let classesButtonAble = {details: classes.details, detailsLabel: classes.detailsLabel};
        let noteList = notes.data || notes;

        return (
            <React.Fragment>
                <Grid container spacing={24} className={classes.vSpace}>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.spaces}>
                            <div className={classes.details}>
                                <List className={classes.fullWidth}>
                                    {renderDetailsRow(i18n.get('contacts.name'), getContactName(contact), classes)}
                                    {contact.street && renderDetailsRow(i18n.get('contacts.address'), contact.street + ' ' + contact.number, classes)}
                                    {contact.zip && renderDetailsRow('', contact.zip + ' ' + contact.city, classes)}
                                    {contact.description && renderDetailsRow(i18n.get('contacts.description'), contact.description, classes)}
                                    {contact.department && renderDetailsRow(i18n.get('contacts.department'), contact.department, classes)}
                                </List>
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.spaces}  style={{height:'100%'}}>
                            <div className={classes.details}>
                                <List className={classes.fullWidth}>
                                    {contact && renderDetailsRow(i18n.get('building.contact'), contact, classes)}
                                    {contact.address_number && renderDetailsRow(i18n.get('contacts.address_number'), contact.address_number, classes)}
                                    {contact.user && renderDetailsRow(i18n.get('building.form.editor'), contact.user.name, classes)}
                                </List>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                <div className={classes.spaces}> </div>
                {contact.is_company && (
                    <React.Fragment>
                        <Paper className={classes.spaces}>
                            <Grid container spacing={24} justify="space-between" alignItems="center">
                                <Grid item>
                                    <Typography variant="h5">{i18n.get('contacts.contacts')}</Typography>
                                </Grid>
                                <Grid item>
                                    <Button className={classes.addButton}
                                            size={"small"}
                                            variant={"contained"}
                                            href={`/contacts/person/create?parent_id=${contact.id}`}
                                            color={"primary"}
                                    >
                                        <Icon fontSize="small">add</Icon>
                                        &nbsp;
                                        {i18n.get('contacts.add')}
                                    </Button>
                                </Grid>
                            </Grid>
                            <Query
                                query={SubContacts.query}
                                variables={{parent_id: contact.id}}
                            >
                                {({loading, error, data}) => {
                                    if (loading) {
                                        return <GraphQlLoading/>;
                                    }
                                    if (error) {
                                        return <GraphQlError/>;
                                    }
                                    return data.contacts.data && data.contacts.data.length > 0
                                        ? <ContactTable contacts={data.contacts.data} setContacts={this.setContacts} parent={contact} />
                                        : <div>{i18n.get('default.empty')}</div>
                                }}
                            </Query>
                        </Paper>
                        <div className={classes.spaces}> </div>
                    </React.Fragment>
                )}
                <Paper className={classes.spaces}>
                    <Grid container spacing={24} justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography variant="h5">{i18n.get('project.notes')}</Typography>
                        </Grid>
                        <Grid item>
                            <Button className={classes.addButton}
                                size={'small'}
                                color={'primary'}
                                variant={'contained'}
                                component={'a'}
                                href={`/notes/create?contact_id=${contact.id}`}
                                icon={'add'}
                            >
                                <Icon>add</Icon>
                                &nbsp;
                                {i18n.get('notes.note_add')}
                            </Button>
                        </Grid>
                    </Grid>

                    {noteList && noteList.length > 0 ? (
                        <NotesList notes={noteList.map((item) => {
                            console.log({
                                ...item,
                            });
                            return {
                                ...item,
                                ...item.note,
                            };
                        })}/>
                    ) : i18n.get('default.empty')}
                </Paper>
            </React.Fragment>
        );
    }
}

const styles = theme => ({
    previewIcon: {
        textAlign: 'center',
    },
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: '100%',
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
    },
    detailsValue: {
        '& > *': {
            ...theme.helpers.oneLiner,
        },
    },
    subContactDescription: {
        display: 'inline',
    },
});

export default withStyles(styles)(ContactDetails);
